const contentData = [
  {
    title: "Upload",
    link: "/upload/1",
    description:
      "Set your location or preferences so you see relevant local offers"
  },
  {
    title: "Shop Securely",
    link: "/upload/2",
    description:
      "Browse and book with local businesses without sharing unnecessary data"
  },
  {
    title: "Tailored for you",
    link: "/upload/3",
    description:
      "See deals and services matched to your area and preferences"
  }
];

export default contentData;
